import type {
	Business,
	BusinessQuery
} from '@/modules/dashboard/dashboardTypes';
import service, { HttpResponseSuccess } from './service';

export interface BusinessesResponse {
	result: Business[];
	count: number;
}

const apiService = service(`${process.env.REACT_BACKEND_HOST}`);

export const getBusinessesLocal = (
	query: BusinessQuery
): Promise<HttpResponseSuccess<BusinessesResponse>> =>
	apiService.get('/api/getBusinesses', { params: query });
